<template>
  <div
    v-if="list.meta"
    :class="list.meta.list_type"
    class="website-list-exposed-filters"
  >
    <template v-for="(item, key) in list.data">
      <component
        :is="list.meta.list_type"
        :item="item"
        :key="key"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
      required: true
    }
  }
}
</script>
